<template>
    <div class="input-group color-picker" ref="colorpicker">
        <input id="color-picker-input" v-model="colorValue" class="form-control" type="text" @focus="showPicker()" @input="updateFromInput" />
        <span class="input-group-addon input-group-append color-picker-container" style="height: 35px;">
            <span class="current-color" :style="'background-color: ' + colorValue + '!important'" @click="togglePicker()"><i class="fas fa-palette input-group-text" :style="'background-color: ' + colorValue + '!important'" style="height: 35px; font-weight: bold; color: #000;"></i></span>
            <chrome-picker :value="colors" @input="updateFromPicker" v-if="displayPicker" @close="isClosed($event)" />
        </span>
    </div>
</template>

<script>
    import { Chrome } from 'vue-color'

    export default {
        name: "design-2021-colorpicker",
        props: ['color'],
        components: {
            'chrome-picker': Chrome
        },
        data () {
            return {
                colors: {
                    hex: '#ffffff',
                },
                colorValue: '',
                displayPicker: false,
            }
        },
        methods: {
            setColor(color) {
                this.updateColors(color);
                this.colorValue = color;
            },
            updateColors(color) {
                if(color.slice(0, 1) == '#') {
                    this.colors = {
                        hex: color
                    };
                }
                else if(color.slice(0, 4) == 'rgba') {
                    var rgba = color.replace(/^rgba?\(|\s+|\)$/g,'').split(','),
                        hex = '#' + ((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2])).toString(16).slice(1);
                    this.colors = {
                        hex: hex,
                        a: rgba[3],
                    }
                }
            },
            showPicker() {
                document.addEventListener('click', this.documentClick);
                this.displayPicker = true;
            },
            hidePicker() {
                document.removeEventListener('click', this.documentClick);
                this.displayPicker = false;
            },
            togglePicker() {
                this.displayPicker ? this.hidePicker() : this.showPicker();
            },
            updateFromInput() {
                this.updateColors(this.colorValue);
            },
            updateFromPicker(color) {
                this.colors = color;
                if(color.rgba.a == 1) {
                    this.colorValue = color.hex;
                }
                else {
                    this.colorValue = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')';
                }
            },
            documentClick(e) {
                var el = this.$refs.colorpicker,
                    target = e.target;
                if(el !== target && !el.contains(target)) {
                    this.hidePicker()
                }
            }
        },
        mounted() {
            this.setColor(this.color || '#ffffff');
        },
        watch: {
            color(val) {
                this.setColor(val || '#ffffff');
            },
            colorValue(val) {
                if(val) {
                    this.updateColors(val);
                    this.$emit('input', val);
                }
            },
            displayPicker(val) {
                if (val) { return; }
                this.$emit('on-close', this.colorValue);
            }
        },
    }
</script>

<style scoped lang="scss">
    .vc-chrome {
        position: absolute;
        z-index: 100;
    }

    .color-picker-container {
        height: auto !important;

        &:hover {
            cursor: pointer;
        }
    }

    .current-color {
        display: flex;
        align-items: center;
        justify-content: center;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-top-right-radius: 12px;
        border-bottom-right-radius: 12px;

        i {
            height: auto !important;
            border: none
        }
    }

</style>

